import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorHandlingService } from 'src/app/shared/error-handling/error-handling.service';
import { SnackBarService } from 'src/app/shared/services/snackBar.service';
import { CompanyApiService } from 'src/app/view-company/service/company-api.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent implements OnInit {
  public email: FormControl;
  public sent = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: string | null = null,
    private cas: CompanyApiService,
    private dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorHandling: ErrorHandlingService
  ) {
    this.email = this.fb.control(this.data, [Validators.required, Validators.email]);
  }

  ngOnInit(): void {}

  public async send(): Promise<void> {
    if (this.sent || this.email.invalid) {
      this.email.markAsTouched();
      return;
    }

    this.sent = true;
    try {
      await this.cas.resetPassword(this.email.value);
      this.snackBar.showSuccess('success.resetPasswd');
      this.dialogRef.close();
    } catch (error) {
      this.errorHandling.showGlobalError('error.resetPasswd', error);
      this.sent = false;
    }
  }
}
